import type { BiomeId } from '@/domain/world/types';
import type { PickedMutation } from '@/domain/mutation/types';

export type RunOutcome = 'in-progress' | 'extracted' | 'fainted' | 'died';

export interface ExpeditionRun {
  id: string;
  biome: BiomeId;
  startedAtMs: number;
  endedAtMs: number | null;
  outcome: RunOutcome;
  enemiesKilled: number;
  xpGained: number;
  pickedMutations: PickedMutation[];
}

export const RUN_XP_PER_KILL_MAP = { fast: 10, ranged: 14, tank: 20 } as const;
export const PICK_AT_KILLS = [3, 8, 15] as const;
export const FAINT_HAPPINESS_PENALTY = 50;
export const FAINT_HP_AFTER = 10;
export const ENEMIES_PER_RUN_INITIAL = 6;
export const ATTACK_HITBOX_W = 28;
export const ATTACK_HITBOX_H = 16;
export const ATTACK_RANGE = 24;
export const ATTACK_COOLDOWN_MS = 350;
export const DODGE_COOLDOWN_MS = 1_200;
export const DODGE_DURATION_MS = 180;
export const DODGE_INVULNERABLE_MS = 220;
export const PLAYER_HIT_INVULNERABLE_MS = 500;
